<onsip-header-main>
  <onsip-header-page-title>E911</onsip-header-page-title>
</onsip-header-main>

<main>
  <div class="mat-headline-4 e911-free-trial">
    {{ "ONSIP_I18N.UPGRADE_TO_GET_STARTED" | translate }}
  </div>
  <div class="mat-body-2 e911-text">
    {{
      "ONSIP_I18N.YOUR_FREE_TRIAL_DOES_NOT_INCLUDE_E911_SERVICES_TO_ACCESS_THIS_ADDON_FEATURE_UPGRADE_TO_A_PAID_PLAN_ACCOUNT"
        | translate
    }}
  </div>

  <button
    mat-flat-button
    color="primary"
    [routerLink]="views.ADMIN_ACCOUNT_SETTINGS_PLAN_OVERVIEW"
    class="e911-upgrade-plan"
  >
    {{ "ONSIP_I18N.UPGRADE_PLAN" | translate }}
  </button>

  <div class="mat-body-2 e911-text">
    {{
      "ONSIP_I18N.REQUIRES_CC__PSTN_BALANCE_FREE_TO_ENABLE__USERBASED_COST_OF_180_PER_MONTH_FOR_EACH_USER_ADDED_TO_A_LOCATION"
        | translate
    }}
  </div>
</main>
